/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_MaturityInputs */

const en_cad_compare_row_maturity = /** @type {(inputs: Cad_Compare_Row_MaturityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maturity`)
};

/**
* | output |
* | --- |
* | "Maturity" |
*
* @param {Cad_Compare_Row_MaturityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_maturity = /** @type {((inputs?: Cad_Compare_Row_MaturityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_MaturityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_maturity(inputs)
});
export { cad_compare_row_maturity as "cad.compare.row_maturity" }